const SYNC_ACTIVITY = [
  {
    item: 'Tax certificate',
    type: 'Evidence',
    case_name: 'Lulama Trading',
    direction: '-> Complyon',
    synced_at: '12 May 09:14',
    status: 'Synced',
    status_tone: 'synced'
  },
  {
    item: 'DoA-014 breach',
    type: 'Control',
    case_name: 'NewGX Capital',
    direction: '<-> Both',
    synced_at: '12 May 08:55',
    status: 'Pending',
    status_tone: 'pending'
  },
  {
    item: 'Activation decision',
    type: 'Decision',
    case_name: 'Kabo Sithole',
    direction: '-> Complyon',
    synced_at: '12 May 08:33',
    status: 'Synced',
    status_tone: 'synced'
  },
  {
    item: 'Conflict declaration',
    type: 'Evidence',
    case_name: 'ABC Tech Solutions',
    direction: '-> Complyon',
    synced_at: '12 May 08:01',
    status: 'Synced',
    status_tone: 'synced'
  },
  {
    item: 'Privileged access list',
    type: 'Control',
    case_name: 'Kabo Sithole',
    direction: '<- Complyon',
    synced_at: '12 May 07:42',
    status: 'Synced',
    status_tone: 'synced'
  },
  {
    item: 'Tax cert expired',
    type: 'Risk event',
    case_name: 'ABC Tech Solutions',
    direction: '-> Complyon',
    synced_at: '11 May 18:21',
    status: 'Action',
    status_tone: 'action'
  }
];

export default {
  name: 'ComplyonSync',
  data: () => ({
    table_search: '',
    sync_activity: SYNC_ACTIVITY
  }),
  computed: {
    filtered_sync_activity() {
      const search = String(this.table_search || '').trim().toLowerCase();

      if (!search) return this.sync_activity;

      return this.sync_activity.filter((activity) => (
        Object.values(activity).join(' ').toLowerCase().includes(search)
      ));
    }
  },
  methods: {
    status_class(tone) {
      return `complyon-sync__status--${tone}`;
    }
  }
};
